<template>
  <div class="addStation">
    <el-form ref="form" :disabled="type == 'look'" :model="form" :rules="rules" label-width="96px"
             label-position="left">

      <el-form-item v-if="type !='edit'" label="机构名称" prop="organizationId">
        <el-select v-model="form.organizationId" filterable>
          <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="type !='edit'" label="站点编码" prop="stationCode">
        <el-input v-model="form.stationCode" maxlength="15" placeholder="请输入站点编码"/>
      </el-form-item>

      <el-form-item label="站点名称" prop="stationName">
        <el-input v-model="form.stationName" maxlength="15" placeholder="请输入站点名称"/>
      </el-form-item>


      <el-form-item label="助记码" prop="mnemonicCode">
        <el-input v-model="form.mnemonicCode" maxlength="15" placeholder="请输入助记码"/>
      </el-form-item>
      <!--      <el-form-item label="默认始发站" prop="startStation">-->
      <!--        <el-radio-group v-model="form.startStation">-->
      <!--          <el-radio :label="0">否</el-radio>-->
      <!--          <el-radio :label="1">是</el-radio>-->
      <!--        </el-radio-group>-->
      <!--      </el-form-item>-->

      <div id="line-form-map" v-if="type !='edit'">
        <div class="line-form-map-serach">
          <choose-address style="width: 100%" :value.sync="form.keyword" placeholder="在地图上搜索位置"
                          :citycode="cityAdcode"
                          @clickRowFn="clickAddressFn"></choose-address>
        </div>
      </div>
      <div style="height: 20px"></div>
      <el-form-item label-width="0" v-if="type == 'edit' || type == 'add'">
        <div class="main-form-btn">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="actionFn" :loading="loading">确定</el-button>
        </div>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
export default {
  name: "addStation",
  props: ['stationId', 'type'],
  data() {
    return {
      form: {
        organizationId: '',
        stationCode: "",
        stationName: "",
        mnemonicCode: "",
        startStation: 0,
        stationAddress: "",
        adCode: "",
        area: "",
        city: "",
        cityCode: "",
        latitude: "",
        longitude: "",
        province: "",
        keyword: '',
      },
      rules: {
        organizationId: [{required: true, message: '请选择机构名称', trigger: ['blur', 'change']}],
        stationCode: [{required: true, message: '请输入站点编码', trigger: ['blur', 'change']}],
        stationName: [{required: true, message: '请输入站点名称', trigger: ['blur', 'change']}],
        mnemonicCode: [{required: true, message: '请输入助记码', trigger: ['blur', 'change']}],
        startStation: [{required: true, message: '请选择', trigger: ['blur', 'change']}],
      },
      mapCtx: null,
      cityAdcode: '',
      mark: null,
      loading: false
    }
  },
  async created() {
    await this.mixinOrganizations();
    this.$set(this.form, "organizationId", this.organizations[0].id);
    this.stationId && await this.getInitFn()
    this.$nextTick(() => {
      this.initMap()
    })
  },
  methods: {
    async getInitFn() {
      const url = '/api/v1/manage/station/base/' + this.stationId
      const {code, data} = await this.$axios.get(url)
      if (code === 1 && data) {
        this.form = {...this.form, ...data, keyword: data.stationName}
      }
    },
    async actionFn() {

      const valid = await this.$refs.form.validate().catch(err => err);

      if (typeof valid === 'boolean' && valid) {

        if (!(this.form.latitude && this.form.longitude)) {
          this.$message.error('请选择站点位置')
          return
        }
        const url = '/api/v1/manage/station/base'
        this.loading = true
        console.log(this.type);
        const {code} = await this.$axios[this.type === 'add' ? 'post' : 'put'](url, this.form)
        this.loading = false
        if (code === 1) {
          this.$message.success('操作成功')
          this.$emit("handSuccess")
        }
      }

    },
   
    clickAddressFn(row) {
      this.handleDouble(row.location, row.name)
    },
    /* 处理双击地图的回调位置 */
    async handleDouble(lnglat, name) {
      let resCity = await this.$AMap.AMapReGeo(lnglat);

      if (resCity) {
        this.mapCtx.clearMap();
        const pois = resCity.regeocode.pois;
        pois.sort((a, b) => a.distance - b.distance);
        let stationName = name ? name : pois && pois[0] && pois[0].name ? pois[0].name : resCity.regeocode.formatted_address;

        this.mark = new AMap.Marker({
          map: this.mapCtx,
          position: lnglat,
          // anchor: "bottom-center",
          animation: "AMAP_ANIMATION_DROP",
          icon: [require("@/assets/img/markerBegin.png"), require("@/assets/img/markerEnd.png")][this.mapType - 1],
          offset: new AMap.Pixel(-2, 0),
        });
        let content = `<div class="markerLabel ${this.mapType == 1 ? "startFC" : "endFC"}">${stationName}</div>`;
        this.mark.setLabel({
          content,
          direction: "top",
          offset: new AMap.Pixel(0, -6),
        });
        this.mapCtx.panTo(lnglat);
        let stationAddress = pois && pois[0] && pois[0].address ? pois[0].address : resCity.regeocode.formatted_address;
        const addressComponent = resCity.regeocode.addressComponent;
        this.form = {
          ...this.form,
          stationAddress: stationAddress,
          area: addressComponent.district,
          adCode: addressComponent.adcode,
          city: addressComponent.city,
          cityCode: addressComponent.citycode,
          province: addressComponent.province,
          longitude: lnglat.lng,
          latitude: lnglat.lat,
          keyword: stationName
        }
        console.log(this.form, 111);

      }
    },
    initMap() {
      if (this.type === 'edit') return
      this.mapCtx = new AMap.Map("line-form-map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        center: new AMap.LngLat(104.065861, 30.657401),
        zoom: 12,
        doubleClickZoom: false
      });

      // 鼠标双击事件
      this.mapCtx.on("dblclick", async (e) => {

        if (this.stationId) return
        this.handleDouble(e.lnglat);
      });

      this.cityAdcode = this.mapCtx.getAdcode();
      if (this.stationId) {
        const position = new AMap.LngLat(this.form.longitude, this.form.latitude);
        this.handleDouble(position, this.form.stationName)
      }

    },
  }
}
</script>

<style scoped lang="less">
.addStation {
  width: 100%;

  #line-form-map {
    width: 100%;
    height: 400px;
    position: relative;
    z-index: 0;

    .line-form-map-serach {
      position: absolute;
      z-index: 999;
      left: 20px;
      top: 20px;
    }


    /deep/ .markerLabel {
      padding: 1rem 1.5rem;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      font-size: 1.5rem;
      color: #ffffff;
      box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

      &.start {
        background-color: #0289ffbb;
      }

      &.startFC {
        background-color: #0289ff;
      }

      &.end {
        background-color: #228b22bb;
      }

      &.endFC {
        background-color: #228b22;
      }
    }
  }
}

</style>